import { render, staticRenderFns } from "./salesLicencelWarnList.vue?vue&type=template&id=9d72d2f8"
import script from "./salesLicencelWarnList.vue?vue&type=script&lang=js"
export * from "./salesLicencelWarnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports